import { render } from "./CrossIcon.vue?vue&type=template&id=0baaf06e"
const script = {}

import exportComponent from "/container/application/releases/20260729235012/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__